export default __webpack_public_path__ + "static/media/icons-category-harp.f013f1cb.svg";